import { defineMessages } from 'react-intl';

const scope = 'app.legacy.main.components.UI';

export default defineMessages({
    rateCalendarLinkButton: {
        id: `${scope}.rateCalendarLinkButton`,
        description: 'Link to the rate calendar',
        defaultMessage: 'View in Rate Calendar',
    },
    lastYearComparisonLabel: {
        id: `${scope}.button.lastYearComparison`,
        defaultMessage: 'Last year comparison',
    },
    labelLastYearComparisonByDay: {
        id: `${scope}.radio.label.lastYearComparisonByDay`,
        defaultMessage: 'Day',
    },
    labelLastYearComparisonByDate: {
        id: `${scope}.radio.label.lastYearComparisonByDate`,
        defaultMessage: 'Date',
    },
});